import { render, staticRenderFns } from "./BindNotify.vue?vue&type=template&id=4cd43db8&"
import script from "./BindNotify.vue?vue&type=script&lang=ts&"
export * from "./BindNotify.vue?vue&type=script&lang=ts&"
import style0 from "./BindNotify.vue?vue&type=style&index=0&id=4cd43db8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports